<script>
import LoaderKaik from "@/components/ui/LoaderKaik.vue";

export default {
  components: { LoaderKaik },
};
</script>

<template>
   <div class="spinner" role="status">
      <div class="spinner-container">
         <LoaderKaik />
      </div>
      <span class="visually-hidden">Cargando</span>
   </div>
</template>
